import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../api";


export const verifyOtpForPhoneUpdate = createAsyncThunk(
  "user-phone-update/verifyOtpForPhoneUpdate",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post("change-phone-number", params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


